import { isBriterBridgesUser } from "./strings";

/**
 * Get the current persona for the user
 *
 * For Briter users: Returns the persona from localStorage (allows persona switching)
 * For regular users: Returns the system_user_type from the user object
 *
 * @param user - The user object from AuthContext
 * @returns The current persona type (FOUNDER, INVESTOR, ACCELERATOR, ACADEMIA, DFI_GOVT)
 */
export const getCurrentPersona = (user?: {
  email?: string;
  system_user_type?: string;
}): string => {
  if (!user) {
    return "FOUNDER"; // Default fallback
  }

  const isBriterUser = isBriterBridgesUser(user.email);

  if (isBriterUser) {
    // For Briter users: check localStorage for persona selection
    const savedPersona = localStorage.getItem("current_persona");
    return savedPersona || user.system_user_type || "FOUNDER";
  }

  // For regular users: always use their system_user_type
  return user.system_user_type || "FOUNDER";
};

/**
 * Set the current persona for a Briter user
 * This is used when switching personas via the persona switcher
 *
 * @param persona - The persona to switch to
 */
export const setCurrentPersona = (persona: string): void => {
  localStorage.setItem("current_persona", persona);
};
